import { IAttribute } from "../../model/formconfiguration/Attribute";
import { IAttributeService } from "../../service/formconfiguration/AttributeService";

export default class CreateAttributeInteractor {
  private attributeService: IAttributeService;

  constructor(attributeService) {
    this.attributeService = attributeService;
  }

  async execute(attribute: IAttribute, formTypeCode: string) {
    await this.attributeService.createAttribute(attribute, formTypeCode);
  }
}
